module.exports = __webpack_public_path__ + "img/copy.0f82a55.svg?v=1791296779994";